import { resolveUserCompletion } from "./type/completion"
import layouts from "./type/layouts"
import schema from "./type/schema"

export default {
  type: "LikertScale",
  icon: "question",
  menu: {
    category: "question",
    order: 5
  },
  layouts,
  resolveUserCompletion,
  schema
}
